import { DEFAULTS, type NotifPrefs } from '../domain/notif-prefs.model';
import type { NotificationPreferencesGateway } from './notification-preferences.gateway';

/**
 * localStorage-backed implementation; the single place that knows the storage
 * key and JSON (de)serialisation. Per-user key `invyo_notification_prefs_<id>`
 * (unchanged from the old flat Settings page, so existing prefs are preserved).
 * Missing / malformed data falls back to `DEFAULTS`. Note: prefs are client-only
 * and do not sync across devices; a known limitation carried over as-is.
 */
const LS_KEY = 'invyo_notification_prefs';

export const localNotificationPreferencesGateway: NotificationPreferencesGateway = {
  load: async (userId: string) => {
    try {
      const raw = localStorage.getItem(`${LS_KEY}_${userId}`);
      if (raw) return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<NotifPrefs>) };
    } catch {
      /* ignore malformed storage */
    }
    return { ...DEFAULTS };
  },
  save: async (userId: string, prefs: NotifPrefs) => {
    localStorage.setItem(`${LS_KEY}_${userId}`, JSON.stringify(prefs));
  },
};
